// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__nStvu","title":"ClientReferral_title__n7iRJ","itemText":"ClientReferral_itemText__2iFmS"};